import { useQuery } from "@tanstack/react-query";
import { getApiInstance } from "./config";

export type DirectusFiles = Array<{ directus_files_id: string }> | { id: string; [key: string]: any; };

type FilesData = {
    entity?: string;
    id?: string | number | null;
    field: string;
    directus_files?: DirectusFiles;
    instanceToUse?: string;
};

export const useFilesData = (files: FilesData) => {
    const filesQueryKey = [`files-${files.entity}-${files.id}-${files.field}-${files.directus_files?.length}-${files.instanceToUse || ''}`];

    return useQuery({
        queryKey: filesQueryKey,
        queryFn: () => getFiles(files.directus_files, files.instanceToUse),
    });
};

const getFiles = async (directus_files?: DirectusFiles, instanceToUse?: string) => {
    if (!directus_files) return [];

    const apiInstance = getApiInstance(instanceToUse);
    const arrayOfFiles = prepareArrayOfFiles(directus_files);

    const files = [];
    for (const file of arrayOfFiles) {
        if (!file.directus_files_id) continue;
        const response = await apiInstance({
            method: "get",
            url: `files/${file.directus_files_id}`,
        });

        files.push(response.data.data);
    }

    return files;
};

const prepareArrayOfFiles = (directus_files: DirectusFiles) => {
    if (Array.isArray(directus_files)) {
        return directus_files;
    } else {
        return [
            {
                directus_files_id: directus_files.id,
            },
        ];
    }
};
